import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Button, Table, Form, InputGroup, Card, Modal } from "react-bootstrap";
import { FaPlus, FaSearch, FaShoppingCart, FaTrash } from "react-icons/fa";
import { BiRupee } from "react-icons/bi";
import { RiSave3Line } from "react-icons/ri";
import { LuPrinter } from "react-icons/lu";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";


const POSRetailAdd = () => {
  const [editablePrices, setEditablePrices] = useState({});
  const [discounts, setDiscounts] = useState("");

  const [commision, setCommision] = useState(""); // Discount in %
  const [packing, setPacking] = useState(""); // Discount in %
  const [gstAmount, setGSTAmount] = useState(""); // Discount in %
  const [cart, setCart] = useState([]);
  const [filteredCodes, setFilteredCodes] = useState([]);
  const [products, setProducts] = useState([]);
  const [fullproducts, setFullProducts] = useState([]);
  const [productCode, setProductCode] = useState("");
  const [productName, setProductName] = useState("");
  const [filteredNames, setFilteredNames] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [loading, setLoading] = useState(true);
  const [Loading1, setLoading1] = useState();
  const [Loading2, setLoading2] = useState();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // const [agent, setAgent] = useState([]);
  const [gst, setGST] = useState({ cgst: "0", sgst: "0", packingCharge: "0.00" });

  const [customer, setCustomer] = useState([]);
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    customerName: "",
    // agent: "",
    address: "",
    place_of_supply: "",
    phonenumber: "",
    // creditlimit:"",
    gstin: "",
    state: "",
  });
  console.log(searchTerm);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  // Handle Form Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    const payload = {
      name: formData.customerName,
      // credit_limit: formData.creditlimit,  // FIXED
      tax_number: formData.gstin,      // FIXED
      telephone: formData.phonenumber,        // FIXED
      address: formData.address,
      place_of_supply: formData.place_of_supply,
      // agent: formData.agent,
      state: formData.state
    };

    console.log("Payload:", payload);

    try {
      const response = await fetch(`${API_BASE_URL}customer_add.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response:", data);

      if (data.head.code === 200) {
        alert("Customer added successfully!");
        setShow(false);
        window.location.reload();
      } else {
        alert("Failed to add customer. Error: " + data.head.msg);
      }
    } catch (error) {
      console.error("Network/API Error:", error);
      alert("Required field is empty");
    }
  };


  const handlePricePerPcsChange = (productId, countOfPcs, value) => {
    const price = parseFloat(value) || 0;

    setEditablePrices((prev) => ({
      ...prev,
      [productId]: {
        price_per_pcs: price,
        rate: price * countOfPcs, // automatically calculate
      },
    }));
  };


  useEffect(() => {
    setLoading(true);
    axios.post(`${API_BASE_URL}pos_api/retail_pos_product_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          setProducts(response.data.body.product);
          setFullProducts(response.data.body.product);
          setCustomer(response.data.body.customer);

          // Extract and store GST details
          const gstData = response.data.body.gst;
          if (gstData) {
            setGST({
              cgst: gstData.cgst,
              sgst: gstData.sgst,
              packingCharge: gstData.packing_charge
            });
            console.log(gstData);

          }
        } else {
          console.error("Error Fetching Data", response.data.head.msg);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 500); // Delay for better UI
      });
  }, []);



  const handleCodeInput = (event) => {
    const code = event.target.value.trim().toUpperCase();
    setProductCode(code);

    if (code.length === 0) {
      setFilteredCodes([]);
      setProductName("");
      return;
    }

    const filtered = products.filter((p) => p.product_code.includes(code));
    setFilteredCodes(filtered);

    const product = products.find((p) => p.product_code === code);

    if (product) {
      setFilteredCodes([]);
      setProductName(product.product_name);
      // ✅ Do NOT call addToCart here
    } else {
      setProductName("");
    }
  };





  // Handle dropdown selection
  const handleDropdownSelect = (product) => {
    setFilteredCodes([]); // Close dropdown
    setFilteredNames([]);

    // Ensure product is valid
    if (!product || !product.product_code || !product.product_name) {
      alert("Invalid product selection!");
      return;
    }

    // Strict stock check
    // if (!product.stock || product.stock <= 0) {
    //   alert(`"${product.product_name}" is out of stock!`);
    //   return;
    // }

    setProductCode(product.product_code);
    setProductName(product.product_name);
    // addToCart(product); // ✅ Add to cart only if in stock
  };




  const handleNameInput = (event) => {
    // const name = event.target.value.trim(); //  white-space not allowed
    const name = event.target.value; // white-space allowed
    setProductName(name);

    if (name.length === 0) {
      setFilteredNames([]);
      setProductCode("");
      return;
    }

    const filtered = products.filter((p) =>
      p.product_name.toLowerCase().includes(name.toLowerCase())
    );
    setFilteredNames(filtered);

    const product = products.find(
      (p) => p.product_name.toLowerCase() === name.toLowerCase()
    );

    if (product) {
      setFilteredNames([]);
      setProductCode(product.product_code);
      // ✅ Do NOT call addToCart here
    } else {
      setProductCode("");
    }
  };




  const addToCart = (product) => {
    setCart((prevCart) => {
      const existingProduct = prevCart.find((item) => item.product_id === product.product_id);
      const inputQty = product.qty || 1; // ✅ Use passed qty or fallback

      if (existingProduct) {
        return prevCart.map((item) =>
          item.product_id === product.product_id
            ? { ...item, qty: item.qty + inputQty } // ✅ Add input quantity
            : item
        );
      } else {
        return [...prevCart, { ...product, qty: inputQty }]; // ✅ Use input quantity
      }
    });
  };



  const handleQtyChange = (e, product) => {
    let prevQty = product.qty; // Store previous quantity
    let newQty = e.target.value.replace(/^0+/, ""); // Remove leading zeros

    if (newQty === "" || isNaN(newQty)) {
      newQty = "";
    } else {
      newQty = parseInt(newQty, 10);

      // ✅ Ensure new quantity is not less than 1
      if (newQty < 1) {
        newQty = 1;
      }

      // ✅ Handle stock limit and show alert correctly
      // if (newQty > product.stock) {
      //     alert(`Only ${product.stock} items available in stock!`);
      //     newQty = product.stock; // Reset to max stock
      // }
    }

    // ✅ Update state correctly
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.product_id === product.product_id ? { ...item, qty: newQty } : item
      )
    );
  };

  // ✅ Ensure Minimum Quantity = 1 on Blur
  const handleQtyBlur = (e, product) => {
    let newQty = parseInt(e.target.value, 10) || 1;
    if (newQty < 1) newQty = 1;

    setCart((prevCart) =>
      prevCart.map((item) =>
        item.product_id === product.product_id ? { ...item, qty: newQty } : item
      )
    );
  };

  const calculateTotal = () => {
    return (
      cart.reduce((total, item) => {
        const editedSellPrice =
          editablePrices[item.product_id]?.rate ?? item.rate;

        return total + (editedSellPrice * item.qty);
      }, 0) || 0
    );
  };
  const calculateNetTotal = () => {
    return (
      cart.reduce((total, item) => {
        const editedSellPrice =
          editablePrices[item.product_id]?.rate ?? item.rate;

        const itemTotal = editedSellPrice * item.qty || 0;
        const discount = discounts[item.product_id] ?? 0;
        const net = itemTotal - (itemTotal * discount / 100);

        return total + net;
      }, 0) || 0
    );
  };



  // Convert packing charge from string to float
  const packingCharge = gst.packingCharge
    ? (parseFloat(gst.packingCharge) / 100) * calculateTotal()
    : 0;

  const total = calculateNetTotal(); // ✅ call the function

  const discountAmount = Math.round((total * discounts) / 100);
  const remainingTotal = total - discountAmount;
  const commisionAmount = Math.round((remainingTotal * commision) / 100);
  const GSTAmount = Math.round((remainingTotal * gstAmount) / 100);

  const packingAmount = Math.round((remainingTotal * packing) / 100);

  const finalTotal = remainingTotal - commisionAmount + packingAmount + GSTAmount;
  const grandtotal = Math.round(finalTotal);

  // ✅ Console Debugging
  console.log("Subtotal:", calculateTotal().toFixed(2));
  console.log("Packing Charge:", packingCharge.toFixed(2));
  console.log("Grand Total:", grandtotal);



  const removeItem = (id) => {
    setCart(cart.filter((item) => item.product_id !== id));
  };

  const handleSave = () => {
    if (!selectedCustomer) {
      alert("Please select a customer.");
      return;
    }
    setLoading1(true);
    if (!cart || cart.length === 0) {
      alert("Please select a product");
      return;
    }


    const orderData = {
      user_id: selectedCustomer.user_id,
      billing_name: selectedCustomer.name,
      billing_phonenumber: selectedCustomer.telephone,
      billing_state: selectedCustomer.state,
      total: grandtotal,
      subtotal: calculateNetTotal(),
      gst_percentage: gstAmount,
      cgst: GSTAmount / 2,
      sgst: GSTAmount / 2,
      packing_charge: packingCharge,
      discount_percentage: discounts,
      discount_amount: discountAmount,
      commision_percentage: commision,
      commision_amount: commisionAmount,
      packing_percentage: packing,
      packing_amount: packingAmount,
      productdetails: cart.map(item => {
        const sellPrice =
          editablePrices[item.product_id]?.rate ?? item.rate;

        // const discountPercent = discounts[item.product_id] ?? 0;
        const total = sellPrice * item.qty;
        // const netTotal = total - (total * discountPercent / 100);

        return {
          product_id: item.product_id,
          product_name: item.product_name,
          qty_per_box: item.qty_per_box,
         
          qty: item.qty,
          amount_per_product: sellPrice,
          total_per_product: total,
        };
      })
    };
    console.log(orderData);
    axios.post(`${API_BASE_URL}pos_api/retail_pos_order.php`, orderData)

      .then(response => {
        if (response.data.head.code === 200) {
          console.log("Order Saved:", response.data);
          alert("Order saved successfully!");
          setCart([]);
          window.location.reload();
        } else {
          console.log("Error", response.data.head.msg)
        }

      })
      .catch(error => {
        console.error("Save Order Error:", error);
        alert("Failed to save order.");
      }).finally(() => {
        setLoading1(false);
      });
  };





  const cleanText = (text) => (text ? text.replace(/[\u200B-\u200D\uFEFF]/g, "").trim().toLowerCase() : "");

  const filteredProducts = fullproducts.filter((product) => {
    const search = cleanText(searchTerm);
    const productName = cleanText(product.product_name);
    const categoryName = cleanText(product.category_name);
    const brand = cleanText(product.brand);

    console.log(`Checking: Brand="${brand}", Search="${search}"`);

    return (
      productName.includes(search) ||
      categoryName.includes(search) ||
      brand.includes(search)
    );
  });


  // ✅ Local quantity state
  const [quantity, setQuantity] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");


  // ✅ Ref for Quantity input
  const quantityRef = useRef(null);
  const productCodeRef = useRef(null); // ✅ New ref


  // ✅ Handle Tab key from Product Code field
  const handleCodeKeyDown = (e) => {
    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      e.preventDefault();
      quantityRef.current?.focus();
    }
  };

  const handleQuantityKeyDown = (e) => {
    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      e.preventDefault();
      productCodeRef.current?.focus();
    }
  };


  const handleQuantityBlur = () => {
    // Perform the same logic as when tabbing on desktop
    const product = products.find((p) => p.product_code === productCode);

    if (product && quantity > 0) {
      // Add to cart with qty
      addToCart({ ...product, qty: Number(quantity) });

      // Reset for next entry
      setProductCode("");
      setProductName("");
      setQuantity("");
      setFilteredCodes([]);

      // Refocus on product code input
      productCodeRef.current?.focus();
    } else {
      alert("Invalid product or quantity");
    }
  };

  const handleDiscountChange = (productId, value) => {
    setDiscounts(prev => ({
      ...prev,
      [productId]: value === "" ? "" : Number(value),
    }));
  };


  return (
    <Container fluid classNam e="p-3" style={{ minHeight: "100vh" }}>
      <Row>
        <Col className="border-end mt-2" style={{
          height: "95vh",
          display: "flex",
          flexDirection: "column",
        }}>
          <InputGroup className="mb-3">
            <Form.Select
              value={selectedCustomer ? selectedCustomer.user_id : ""} // ✅ Ensures dropdown resets
              onChange={(e) => {
                const user = customer.find(c => c.user_id === e.target.value);
                setSelectedCustomer(user || null); // ✅ Update or reset properly
              }}
            >
              <option value="">Select Customer</option>
              {Array.isArray(customer) && customer.map((c) => (
                <option key={c.user_id} value={c.user_id}>{c.name}</option>
              ))}
            </Form.Select>
            &nbsp; &nbsp;
            <Button variant="primary" onClick={handleShow} style={{ marginTop: "0px" }} >
              <FaPlus />
            </Button>&nbsp;&nbsp;
            <Button className="btn btn-solid pos-back-btn" onClick={() => window.history.back()}>
              Back
            </Button>
          </InputGroup>


          <Row>
            <Col md={4}>
              <InputGroup className="mb-3">
                <Form.Control
                  ref={productCodeRef} // ✅ Attach ref
                  type="text"
                  placeholder="Enter Product Code"
                  value={productCode}
                  onChange={handleCodeInput}
                  onKeyDown={handleCodeKeyDown} // 👈 Listen for Tab key
                  autoComplete="off"
                />
                {Array.isArray(filteredCodes) && filteredCodes.length > 0 && (
                  <div
                    className="dropdown-menu show"
                    style={{
                      width: "100%",
                      marginTop: "50px",
                      overflowY: "scroll",
                      height: "50vh",
                    }}
                  >
                    {filteredCodes.map((product) => (
                      <div
                        key={product.product_id}
                        style={{ cursor: "pointer", color: "black" }}
                        className="dropdown-item"
                        onClick={() => handleDropdownSelect(product)}
                      >
                        {product.product_code} - {product.product_name}
                      </div>
                    ))}
                  </div>
                )}
              </InputGroup>
            </Col>

            <Col md={4}>

              <InputGroup className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Enter Product Name"
                  value={productName}
                  onChange={handleNameInput}
                  onKeyDown={handleCodeKeyDown}
                  autoComplete="off"
                />
                {Array.isArray(filteredNames) && filteredNames.length > 0 && (
                  <div
                    className="dropdown-menu show"
                    style={{
                      width: "100%",
                      marginTop: "50px",
                      overflowY: "scroll",
                      height: "50vh",
                    }}
                  >
                    {filteredNames.map((product) => (
                      <div
                        key={product.product_id}
                        style={{ cursor: "pointer", color: "black" }}
                        className="dropdown-item"
                        onClick={() => handleDropdownSelect(product)}
                      >
                        {product.product_name} - {product.product_code}
                      </div>
                    ))}
                  </div>
                )}
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup className="mb-3">

                <Form.Control
                  ref={quantityRef}
                  type="number"
                  placeholder="Enter Quantity"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  onKeyDown={handleQuantityKeyDown}
                  onBlur={handleQuantityBlur}  // Handle when focus is lost (on mobile and desktop)
                />
              </InputGroup>
            </Col>

          </Row>

          {/* Table to Display Selected Products */}
          <div style={{ flexGrow: 1, overflowY: "auto", border: "1px solid #ddd" }}>
            <Table bordered responsive>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Item</th>
                  <th style={{ textAlign: "right" }}>Rate</th>
                  <th>Qty</th>
                  <th style={{ textAlign: "right" }}>Total</th>
                  <th>Del</th>
                </tr>
              </thead>
              <tbody>
                {/* {cart.map((item, index) => { */}
                {[...cart].reverse().map((item, index) => {
                  const pricePerCase = editablePrices[item.product_id]?.rate ?? item.rate;
                  const total = (pricePerCase * item.qty) || 0;
                  // const discount = discounts[item.product_id] ?? "";
                  // const netTotal = total - (total * discount / 100);

                  return (
                    <tr key={item.product_id}>
                      <td>{index + 1}</td>
                      <td>{item.product_name} - ({item.qty_per_box})</td>

                      <td style={{ textAlign: "right" }}>
                        <input
                          type="number"
                          step="1"
                          value={editablePrices[item.product_id]?.rate ?? item.rate}
                          onChange={(e) =>
                            handlePricePerPcsChange(item.product_id, item.count_of_pcs, e.target.value)
                          }
                          style={{ width: "80px", textAlign: "right" }}
                        />
                      </td>

                      {/* <td style={{ textAlign: "right" }}>
                        <BiRupee />
                        {pricePerCase}
                      </td> */}

                      <td>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <input
                            type="number"
                            value={item.qty}
                            min="1"
                            className="form-control text-center"
                            style={{ width: "60px" }}
                            onInput={(e) => handleQtyChange(e, item)}
                            onBlur={(e) => handleQtyBlur(e, item)}
                          />

                        </div>
                      </td>

                      <td style={{ textAlign: "right" }}>
                        <BiRupee />
                        {total.toFixed(2)}
                      </td>



                      {/* Delete Button */}
                      <td>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => removeItem(item.product_id)}
                        >
                          <FaTrash />
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

          </div>

          <div className="bg-light p-3 border rounded d-flex justify-content-between print-btn-group">

            <>
              <div className="print-btn">
                <Button variant="dark" onClick={handleSave} style={{ height: "40px" }}>

                  {Loading1 ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <>
                      <RiSave3Line /> &nbsp; Save
                    </>
                  )}
                </Button>

                &nbsp;&nbsp;
              </div>
            </>

            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", width: "250px" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>Sub-Total:</h6>
                <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{calculateNetTotal().toFixed(2)}</h6>
              </div>
              <div style={{ fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>
                  <input
                    type="number"
                    placeholder="Enter Discount %"
                    value={discounts}
                    onChange={(e) => setDiscounts(Number(e.target.value))}
                    style={{
                      padding: "6px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "100%"
                    }}
                  />
                </h6>
              </div>


              <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>Discount Amount:</h6>
                <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{discountAmount.toFixed(2)}</h6>
              </div>


              {/* Packing Input */}
              <div style={{ fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>
                  <input
                    type="number"
                    placeholder="Enter packing %"
                    value={packing}
                    onChange={(e) => setPacking(Number(e.target.value))}
                    style={{
                      padding: "6px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "100%"
                    }}
                  />
                </h6>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>Packing Amount:</h6>
                <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{packingAmount.toFixed(2)}</h6>
              </div>


              <div style={{ fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>
                  <input
                    type="number"
                    placeholder="Enter GST %"
                    value={gstAmount}
                    onChange={(e) => setGSTAmount(Number(e.target.value))}
                    style={{
                      padding: "6px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "100%"
                    }}
                  />
                </h6>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>GST Amount:</h6>
                <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{GSTAmount.toFixed(2)}</h6>
              </div>



              <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>Grand Total:</h6>
                <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{grandtotal.toFixed(2)}</h6>
              </div>
            </div>

          </div>

        </Col>


      </Row>
      {/* -------------Customer Add Modal  Start --------------- */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>


            {/* Customer Name */}
            <Form.Group className="mb-3">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                type="text"
                name="customerName"
                value={formData.customerName}
                onChange={handleChange}
                placeholder="Enter Customer Name"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                name="phonenumber"
                value={formData.phonenumber}
                onChange={handleChange}
                placeholder="Enter Phone Number"
                required
                maxLength={10}
              />
            </Form.Group>



            {/* Address */}
            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter Address"
                rows={3}

              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <Form.Control
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="Enter State"

              />
            </Form.Group>


            {/* GSTIN/UIN */}
            <Form.Group className="mb-3">
              <Form.Label>GSTIN/UIN</Form.Label>
              <Form.Control
                type="text"
                name="gstin"
                value={formData.gstin}
                onChange={handleChange}
                placeholder="Enter GSTIN/UIN"
                maxLength={15}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Place of Supply</Form.Label>
              <Form.Control
                type="text"
                name="place_of_supply"
                value={formData.place_of_supply}
                onChange={handleChange}
                placeholder="Enter Place of Supply"
              // rows={3}

              />
            </Form.Group>

            {/* Submit Button */}
            <Button variant="success" type="submit">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      {/* -------------Customer Add Modal  End --------------- */}
    </Container>
  );
};

export default POSRetailAdd;
